import { createI18n } from 'vue-i18n'

import { resolveInitialLocale } from './languages'
import en from './locales/en'
import sl from './locales/sl'

export type AvailableLocales = 'sl' | 'en'

const messages = { sl, en }

const i18n = createI18n({
    legacy:           false,
    globalInjection:  true,
    locale:           resolveInitialLocale(),
    fallbackLocale:   'en',
    messages,
    availableLocales: Object.keys(messages),
})

export default i18n
